import { Component, OnInit, ViewChild, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { CarteraService } from 'app/services/cartera/cartera.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-beneficiarios-x-grupo',
  templateUrl: './beneficiarios-x-grupo.component.html',
  styleUrls: ['./beneficiarios-x-grupo.component.scss']
})
export class BeneficiariosXGrupoComponent implements OnInit, OnDestroy, AfterViewInit {

  // Variables DataTable //
  public dtOptions;
  public tableOpt = [];
  @ViewChild(DataTableDirective , {static: true}) tabla: DataTableDirective;
  public dtTrigger: Subject<void> = new Subject();

  /**
   * Constructor
   *
   * @param {CarteraService} _cartera
   * @param data
   */
  constructor
  (
    private _cartera: CarteraService,
    @Inject(MAT_DIALOG_DATA) private data,
  )
  {
    this.getBeneficiariosxGrupo(data);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.dtOptions = {
      order: [2, 'desc'],
      scrollCollapse: true,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          data: 'documento'
        },
        {
          data: 'nombre_completo'
        },
        {
          data: 'fecha_ingreso'
        },
        {
          data: 'fecha_baja'
        },
        {
          data: 'total_servicios'
        },
        {},
        {
          data: 'tipo_baja'
        }
      ],
      responsive: true
    }
    this.dtTrigger.next();
  }

  /**
   * After View Init
   */
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Trae los beneficiarios del grupo correspondiente
   * @param {Documento: string, Radicado: string} infoGrupo
   */
  getBeneficiariosxGrupo(infoGrupo: {Documento: string, Radicado: string,empresa:string}): void{
    this._cartera.VerBeneficiariosxGrupo(infoGrupo.Documento, infoGrupo.Radicado,infoGrupo.empresa).subscribe((data: any) => {
      this.tableOpt = data;
      this.renderer();
    });
  }

  /**
   * Renderiza la tabla
   */
  public renderer(): void{
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }



}
